// Dependencies
import React, { Component } from "react";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";

// Store
import { mailingStore } from "../store/store";

// Components
import Lists from "./Lists/Lists.component";
import MailingConfiguration from "./MailingConfiguration/MailingConfiguration.component";
import Footer from "../../home/components/Footer/footer.component";
// Styles
import "./MailingLists.component.scss";
import { checkPermission } from "../../../utils/Authorization/authorization";

class MailingLists extends Component {
    render() {
        return (
            <Provider store={mailingStore}>
                <div id="MailingLists">
                    <Switch>
                        {checkPermission("edit_mailing_list") && (
                                <Route
                                    path={"/admin/mailing/new"}
                                    component={MailingConfiguration}
                                />
                            )}
                        {checkPermission("edit_mailing_list") && (
                                <Route
                                    path={"/admin/mailing/edit/:presetId"}
                                    component={MailingConfiguration}
                                />
                            )}

                        <Route
                            path="/admin/mailing/detail/:presetId"
                            component={MailingConfiguration}
                        />
                        <Route path={"/admin/mailing"} component={Lists} />
                    </Switch>
                    <Footer />
                </div>
            </Provider>
        );
    }
}

export default MailingLists;
